import React from 'react';

import './Close.scss';

const IconClose = ({width = '14', height = '14', className}) => (
    <svg
        width={width}
        height={height}
        className={`Svg ${className}`}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.3 0.709727C12.91 0.319727 12.28 0.319727 11.89 0.709727L6.99997 5.58973L2.10997 0.699727C1.71997 0.309727 1.08997 0.309727 0.699971 0.699727C0.309971 1.08973 0.309971 1.71973 0.699971 2.10973L5.58997 6.99973L0.699971 11.8897C0.309971 12.2797 0.309971 12.9097 0.699971 13.2997C1.08997 13.6897 1.71997 13.6897 2.10997 13.2997L6.99997 8.40973L11.89 13.2997C12.28 13.6897 12.91 13.6897 13.3 13.2997C13.69 12.9097 13.69 12.2797 13.3 11.8897L8.40997 6.99973L13.3 2.10973C13.68 1.72973 13.68 1.08973 13.3 0.709727Z"
            fill="#2B2B2B"
        />
    </svg>
);

export default IconClose;
